import { useState, useCallback } from 'react';
import dayjs from 'dayjs';
import { NavigationOptions } from '../components/CalendarToolbar';

export const useCalendarNavigation = () => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const handleNavigate = useCallback((action: NavigationOptions) => {
    setCurrentDate((prevDate) => {
      if (action === NavigationOptions.PREV) {
        const newDate = dayjs(prevDate).subtract(1, 'month').toDate();
        return newDate;
      } else if (action === NavigationOptions.NEXT) {
        return dayjs(prevDate).add(1, 'month').toDate();
      } else if (action === NavigationOptions.TODAY) {
        return new Date();
      }
      return prevDate;
    });
  }, []);

  return {
    currentDate,
    setCurrentDate,
    handleNavigate,
  };
};
